import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button', 'menu'];

  connect() {
    // Close dropdown when clicking outside
    this.handleClickOutside = this.clickOutside.bind(this);
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnect() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  toggle(event) {
    event.stopPropagation();

    if (this.menuTarget.classList.contains('tw-hidden')) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.menuTarget.classList.remove('tw-hidden');
    // Find the icon within the button and rotate it
    const icon = this.buttonTarget.querySelector('.fa-angle-down');
    if (icon) {
      icon.classList.add('tw-rotate-180');
    }
  }

  close() {
    this.menuTarget.classList.add('tw-hidden');
    // Find the icon within the button and reset rotation
    const icon = this.buttonTarget.querySelector('.fa-angle-down');
    if (icon) {
      icon.classList.remove('tw-rotate-180');
    }
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close();
    }
  }

  selectOption(event) {
    const selectedText = event.currentTarget.textContent.trim();
    this.labelTarget.textContent = selectedText;
    this.close();
  }
}
